<template>
  <v-row>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12" sm="6" md="6">
          <v-card-title>
            <h1 class="simepar-title">
              Simepar
            </h1>
          </v-card-title>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-card-text>
            <p class="simepar-title-text">
              Uma equipe altamente qualificada, que combina tecnologia e um
              modelo de gestão empresarial orientado para a qualidade e inovação
              com responsabilidade social.
            </p>
          </v-card-text>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-card-title>
            <h1 class="simepar-subtitle">Excelência tecnológica</h1>
          </v-card-title>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-card-text class="ml-5">
            <v-icon>mdi-circle</v-icon>
            <p class="simepar-subtitle-text">
              Previsões realizadas com base em telemetria e sensoriamento
              automático de dados.
            </p>
            <v-icon>mdi-circle</v-icon>
            <p class="simepar-subtitle-text">
              Modelos númericos e análise crítica de profissionais capacitados
            </p>
            <v-icon>mdi-circle</v-icon>
            <p class="simepar-subtitle-text">
              Modernos equipamentos e sistemas computacionais inteligentes
              viabilizam a recepção, o processamento e a disseminação de dados e
              informações em tempo real
            </p>
          </v-card-text>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="6" md="6" class="mb-5 ml-6">
          <v-avatar size="290px">
            <v-img :src="require('@/assets/arte.png')" alt="Arte Infohidro" />
          </v-avatar>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
export default {
  data: () => ({}),
};
</script>

<style scoped>
@font-face {
  font-family: 'Poppins';
  src: local('Poppins'), url('../../assets/fonts/Poppins/Poppins-SemiBold.ttf') format("truetype");
}

@font-face {
  font-family: 'Questrial';
  src: local('Questrial'), url('../../assets/fonts/Questrial/Questrial-Regular.ttf') format("truetype");
}


.simepar-title {
  /*position: absolute;*/
  width: 125px;
  height: 33px;
  left: 0px;
  top: 5px;

  font-family: "Questrial", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 33px;
  /* identical to box height */

  display: flex;
  align-items: center;

  /* UI Fonte Branca */

  color: #ffffff;
}

.simepar-title-text {
  /*position: absolute;*/
  width: 312px;
  height: 140px;
  left: 0px;
  top: 47px;

  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 28px;

  color: #ffffff;
}

.simepar-subtitle {
  /*position: absolute;*/
  width: 255px;
  height: 25px;
  left: 0px;
  top: 207px;

  font-family: "Questrial", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 25px;
  /* identical to box height */

  display: flex;
  align-items: center;

  /* UI Fonte Branca */

  color: #ffffff;
}

.simepar-subtitle-text {
  /*position: absolute;*/
  width: 311px;
  /*height: 308px;*/
  left: 0px;
  top: 244px;

  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 28px;
  /* or 175% */

  /* UI Fonte Branca */

  color: #ffffff;
}

.v-icon {
  position: absolute;
  font-size: 4px;
  margin-top: 10px;
  margin-left: -14px;
}
</style>
